import { Footer } from '@/components/Footer'
import { SEO } from '@/components/SEO'
import { TermsConditions } from '@/components/TermsConditions'
import { SEO_CONFIG } from '@/constants/seo'

export const TermsConditionsPage = () => {
    return (
        <>
            <SEO
                title='Terms and Conditions - Nexly'
                description='Read Nexly terms and conditions for using our automated financial statement review software. Understand your rights and responsibilities.'
                canonical={`${SEO_CONFIG.siteUrl}/terms-conditions`}
                ogImage={SEO_CONFIG.ogImage}
            />
            <TermsConditions/>
            <Footer/>
        </>
    )
}
